import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, hasPermission, isPortalAuthenticated } from '../utils/auth';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';

/**
 * 私有路由组件 - 需要登录才能访问
 */
export const PrivateRoute = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    // 未登录，重定向到登录页，并保存当前路径
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

/**
 * 权限路由组件 - 需要特定权限才能访问
 */
export const PermissionRoute = ({ children }) => {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission(location.pathname)) {
    // 无权限，显示403页面
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <Result
          status="403"
          title="403"
          subTitle="抱歉，您没有权限访问此页面"
          icon={<LockOutlined style={{ fontSize: 72, color: '#ff4d4f' }} />}
          extra={
            <Button type="primary" onClick={() => window.history.back()}>
              返回上一页
            </Button>
          }
        />
      </div>
    );
  }

  return children;
};

/**
 * 公开路由组件 - 已登录用户不能访问（如登录页）
 */
export const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    // 已登录，重定向到首页
    return <Navigate to="/" replace />;
  }

  return children;
};

/**
 * 维修门户路由守卫 - 需客户门户登录态（portal_token）
 */
export const PortalRoute = ({ children }) => {
  if (!isPortalAuthenticated()) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
};
